export default {
  name: "Countdown",
  props: ["timeLeft", "countdownLabelClass"],
  data() {
    return {
      secondsLeft: this.timeLeft
    };
  },
  created: function() {
    setTimeout(
      function() {
        this.decrement();
      }.bind(this),
      1000
    );
  },
  updated: function() {
    if (this.secondsLeft > 0) {
      // set seconds left
      setTimeout(
        function() {
          this.decrement();
        }.bind(this),
        1000
      );
    }
  },
  computed: {
    remainingHours: function() {
      return Math.floor(this.secondsLeft / 3600);
    },
    remainingMinutes: function() {
      return Math.floor((this.secondsLeft % 3600) / 60);
    },
    remainingSeconds: function() {
      return Math.floor((this.secondsLeft % 3600) % 60);
    },
    showTime: function() {
      return this.secondsLeft > 0;
    }
  },
  methods: {
    decrement: function() {
      if (this.secondsLeft > 1) this.secondsLeft = this.secondsLeft - 1;
      else {
        this.secondsLeft = 0;
      }
    }
  }
};
